/*PROJECT LIST*/
Vue.component('projectlist',{
    template:'#projectlist-template',
    data:function(){
        return{
            client: [],
            project: [],
            activeTab:'personaldata',
            backupRecord:[],
            password:'',
            password_verify:'',
            passwordFieldIsActive:false,
            brands:[],
            subBrands:[],
            activeClient:'',
            activeBrand:'',
            activeBrandId:'',
            activeSubBrand:'',
            activeSubBrandId:'',
            projectName:'',
            projectDeadLine:'',
            projectStart:'',
            projects:'',
            recentProjectNumbers:[],
            projectnumbersearchstring:'',
        };
    },
    created:function(){
        setTimeout(function(){
            $(function () {
                $('#datetimepicker5').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu'
                });
                $('#datetimepicker6').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu'
                });

            });
        },300);

        activeInstance = this;
        var id = $('#content_wrapper').attr('data-id');

        activeInstance.getAllProjectsForCurrentYear();


    },
    events: {
        //ON CLIENT SELECTION
        'autocomplete-result:selected': function(data){
            //console.log(data);
            activeInstance.activeClient = data;
            activeInstance.getClientBrands(data.id);
        }
    },
    methods:{
        getAllProjectsForCurrentYear:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL + '/api/projects/list/all', function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.projects = response;
            });
        },
        edit:function(project){
            location.href = baseURL+'/admin/project/edit/'+project.id;
        },
        destroy:function(project){
            bootbox.confirm('Biztosan el akarod távolítani ezt a projektet?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/project/destroy',{project:project}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        successNotification('A projekt törölve.');
                        activeInstance.projects.$remove(project);
                    });
                }
            });
        },

        //GET BRANDS BELONGS TO A CLIENT
        getClientBrands:function(id){
            activeInstance.activeBrandId='';
            activeInstance.activeBrand='';
            activeInstance.activeSubBrandId='';
            activeInstance.activeSubBrand='';
            activeInstance.$http.get(baseURL+'/api/brand/list/client/'+activeInstance.activeClient.id).then(function(response){
                activeInstance.brands = response.data;
            }).bind(this);
        },

        //WHEN SELECTING A BRAND -> GET THE BELONGING SUB BRANDS
        getBrandSubBrands:function(event,data){
            var activeBrand = $(event.target).val();
            activeInstance.activeBrandId = activeBrand;

            $.each(activeInstance.brands, function(index,brand){
                console.log('searching...');

                if(brand.id==activeInstance.activeBrandId){
                    console.log('found...');
                    activeInstance.activeBrand = brand;
                }
            });

            activeInstance.$http.get(baseURL+'/api/sub_brand/list/brand/'+activeInstance.activeBrandId).then(function(response){
                //console.log(response);
                activeInstance.subBrands = response.data;
            }).bind(this);


        },
        setActiveSubBrand:function(event){

            var subBrandId = $(event.target).val();
            $.each(activeInstance.subBrands, function(index,sub_brand){
                console.log('searching...');

                if(sub_brand.id==subBrandId){
                    console.log('found...');
                    activeInstance.activeSubBrand = sub_brand;
                }
            });
        }
    }
});